import { render, staticRenderFns } from "./pay_sheet.vue?vue&type=template&id=6fc5c246"
import script from "./pay_sheet.vue?vue&type=script&lang=js"
export * from "./pay_sheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports